function sendCustomEvent(name, detail = {}) {
    const customEvent = new CustomEvent(name, {
        bubbles: true,
        detail: detail
    });
    document.dispatchEvent(customEvent);
}

export {
    sendCustomEvent
}
